import { createAction, props } from '@ngrx/store';
import { ICustomerCard } from '../../../core/models/customer.model';
import {
  ICreateLoan,
  ICreatePreLoan,
  ICustomer,
  ICustomerValidate,
  IInstallmentsConfig,
} from '../../../core/models/customer.model';

export const requestCustomerInformation = createAction('[App] Request Customer Information');

export const successRequestCustomerInformation = createAction(
  '[Customer] Success Request Customer Information',
  props<{ customer: ICustomer }>()
);

export const failureRequestCustomerInformation = createAction(
  '[Customer] Failure Request Customer Information',
  props<{ error: string }>()
);

export const listenUserScore = createAction('[Customer] Listen User Score');

export const successListenUserScore = createAction(
  '[Customer] Success Listen User Score',
  props<{ validation: ICustomerValidate }>()
);

export const failureListenUserScore = createAction(
  '[Customer] Failure Listen User Score',
  props<{ error: string }>()
);

export const updateLoading = createAction(
  '[Customer] Update Loading',
  props<{ isLoading: boolean }>()
);

export const requestPreLoan = createAction('[Customer] Request Pre-Loan');

export const successRequestPreLoan = createAction(
  '[Customer] Success Request Pre-Loan',
  props<{ preLoan: IInstallmentsConfig[] }>()
);

export const failureRequestPreLoan = createAction(
  '[Customer] Failure Request Pre-Loan',
  props<{ error: string }>()
);

export const createPreLoan = createAction(
  '[Customer] Create Pre Loan',
  props<{ createPreLoan: ICreatePreLoan }>()
);

export const successCreatePreLoan = createAction(
  '[Customer] Success Create Pre Loan',
  props<{ id: string }>()
);

export const updateIsLoadingPreLoan = createAction(
  '[Customer] Update Is Loading PreLoan',
  props<{ isLoadingPreLoan: boolean }>()
);

export const failureCreatePreLoan = createAction(
  '[Customer] Failure Create Pre Loan',
  props<{ error: string }>()
);

export const redirectToEcommerce = createAction(
  '[Customer] Redirect to the Ecommerce',
  props<{ portal: boolean }>()
);

export const getCustomerCard = createAction('[Customer] Get Card Information');

export const successGetCustomerCard = createAction(
  '[Customer] Success Get Card Information',
  props<{ cardInfo: ICustomerCard }>()
);

export const failureGetCustomerCard = createAction(
  '[Customer] Failure Get Card Information',
  props<{ error: string }>()
);

// DEMO

export const redirectUserToScore = createAction('[Customer] Redirect User to Score Page');

export const setCustomerInformation = createAction(
  '[Customer] Set Customer Information',
  props<{ customer: ICustomer }>()
);

export const setCustomerValidate = createAction(
  '[Customer] Set Customer Validate',
  props<{ validation: ICustomerValidate }>()
);

// DEMO
